import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { ValidatorForm } from "react-material-ui-form-validator";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Utils from "../../../provider/Utils";
import MenuWithBreadScrum from "../menu/MenuWithBreadScrum";
import CreateButton from "../buttons/CreateButton";
import CancelIconButton from "../buttons/CancelIconButton";
import FetchServerData from "../../../provider/FetchServerData";
import PtsAlert from "../ptsAlert/PtsAlert";
import store from "../../../redux/store";
import SaveButton from "../buttons/SaveButton";
import BackButton from "../buttons/BackButton";
import {
  CreateGroupContact_Url,
  DeleteContactFromGroup_Url,
  DeleteContact_Url,
  FindByNumber_Url,
  GetContact_Url,
  UpdateContact_Url,
} from "../../../provider/ServiceUrl";
import { BUSINESS_DOMAIN } from "../../../provider/Enums";

class NewContact extends Component {
  header = store.getState().header.header;
  companyName =
    store.getState().appUserData.appUserData.appuser?.organization?.name;
  defaultCountry = store.getState().staticData.defaultCountry;
  businessDomain =
    store.getState().appUserData.appUserData.appuser?.businessDomain;
  businessDomainId = store.getState().businessDomain?.businessDomainId;
  constructor(props) {
    super(props);
    let action = props.action;
    let groupId = props.groupId;
    let groupName = props.groupName;
    let contactId = props.contactId;
    let pageId = props.pageId;
    let allContactBreadCrumb = [
      { pageid: "/contacts", uiname: "All Active List" },
      { pageid: "", uiname: "Contact Details" },
    ];
    let allEventContactBreadCrumb = [
      { pageid: "/eventContacts", uiname: "All Contact List" },
      { pageid: "", uiname: "Contact Details" },
    ];
    let allDptextContactBreadCrumb = [
      { pageid: "/dptextContacts", uiname: "All Contact List" },
      { pageid: "", uiname: "Contact Details" },
    ];
    let givbeeBreadCrumb = [
      { pageid: "/groups", uiname: "Groups" },
      { pageid: "/group", uiname: "Group Details" },
      { pageid: "", uiname: "Contact Details" },
    ];
    let eventBreadCrumb = [
      { pageid: "/eventGroups", uiname: "Groups" },
      { pageid: "/eventGroup", uiname: "Group Details" },
      { pageid: "", uiname: "Contact Details" },
    ];
    let dptextBreadCrumb = [
      { pageid: "/dptextGroups", uiname: "Groups" },
      { pageid: "/dptextGroup", uiname: "Group Details" },
      { pageid: "", uiname: "Contact Details" },
    ];
    if (!action && props.state) {
      action = props.state.action;
      groupId = props.state.groupId;
      groupName = props.state.groupName;
      contactId = props.state.contactId;
      pageId = props.state.pageId;
    }
    let breadCrumb = [];

    if (pageId === "AllActives") {
      if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
        breadCrumb = allEventContactBreadCrumb;
      } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
        breadCrumb = allDptextContactBreadCrumb;
      } else {
        breadCrumb = allContactBreadCrumb;
      }
    } else {
      if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
        breadCrumb = eventBreadCrumb;
      } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
        breadCrumb = dptextBreadCrumb;
      } else {
        breadCrumb = givbeeBreadCrumb;
      }
    }

    if (null !== contactId && contactId > 0) {
      this.getContactDetails(contactId);
    }
    // if (
    //   action &&
    //   Utils.equalsIgnoreCase(
    //     action,
    //     "view" || Utils.equalsIgnoreCase(action, "update")
    //   )
    // ) {
    //   this.getContactDetails(contactId);
    // }
    this.state = {
      action: action,
      breadCrumb: breadCrumb,
      groupId: groupId,
      groupName: groupName,
      pageId: pageId,
      mobileNo: "",
      mobile: "",
      firstName: "",
      lastName: "",
      email: "",
      countryCode:
        this.defaultCountry !== null
          ? `+${this.defaultCountry?.phoneCode}`
          : "",
      getUpdatePermission: false,
      getDeletePermission: false,
      isOptin: false,
      error: false,
      isActive: false,
      addAnotherContact: false,
      render: false,
    };
  }

  getContactDetails(contactId) {
    const postObject = {
      header: this.header,
      smsContact: {
        id: contactId,
      },
    };
    FetchServerData.callPostService(GetContact_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          let smsContact = output.data.smsContact;
          let getPermission = Utils.getRolePermission(["*"]);
          let getUpdatePermission = getPermission[3];
          let getDeletePermission = getPermission[4];
          let mobileNo = Utils.viewTollFreeNumberFormate(smsContact.mobile);
          this.setState({
            render: true,
            // action: this.state.pageId === "AllActives" ? "edit" : "view",
            action: "edit",
            mobileNo: mobileNo,
            mobile: smsContact.mobile,
            countryCode: smsContact.countryCode,
            firstName: smsContact?.firstName,
            lastName: smsContact?.lastName,
            email: smsContact?.email,
            isOptin: smsContact.isOptin,
            isActive: smsContact.isActive,
            contactId: smsContact.id,
            getUpdatePermission: getUpdatePermission,
            getDeletePermission: getDeletePermission,
          });
        } else {
        }
      })
      .catch((error) => { });
  }
  handleMobileNoChange(e) {
    let val = e.target.value;
    if (val.length <= 12) {
      let value = Utils.phoneNumberFormate(val);
      let mobile = e.target.value.replace(/-/g, "");
      if (mobile.length === 10) {
        this.searchExistingMobileNo(value);
      }
      this.setState({
        mobileNo: value,
        mobile: mobile,
      });
    }
  }

  handleCountryChange(phone, country, e, formattedValue) {
    // let mobileNo = formattedValue.split(" ");
    // this.setState({
    //   mobile: phone,
    //   mobileNo: mobileNo[1]?.replace(/-/g, ""),
    //   countryCode: formattedValue,
    // });
    this.setState({
      countryCode: formattedValue,
    });
  }

  searchExistingMobileNo(mobileNo) {
    const postObject = {
      header: this.header,
      smsContact: {
        mobile: mobileNo,
        countryCode: this.state.countryCode,
      },
    };
    if (
      !Utils.isNullOrEmpty(this.state.mobileNo) &&
      this.state.mobileNo.length >= 10
    ) {
      FetchServerData.callPostService(FindByNumber_Url, postObject).then(
        (output) => {
          if (output.status === "SUCCESS") {
            let smsContact = output.data.smsContact;
            this.setState({
              firstName: smsContact?.firstName,
              lastName: smsContact?.lastName,
              email: smsContact?.email,
              // isOptin: smsContact?.isOptin,
            });
          } else {
          }
        }
      );
    }
  }

  handleFirstNameChange(e) {
    this.setState({ firstName: e.target.value });
  }
  handleLastNameChange(e) {
    this.setState({ lastName: e.target.value });
  }
  handleEmailChange(e) {
    this.setState({ email: e.target.value });
  }

  handleOptinChange(e) {
    this.setState({ isOptin: e.target.checked, error: false });
  }

  createGroupContactToBackend() {
    if (!this.state.isOptin) {
      this.setState({
        error: true,
      });
      return;
    }
    const postObject = {
      header: this.header,
      smsGroupContact: {
        smsGroup: {
          id: this.state.groupId,
        },
        smsContact: {
          mobile: this.state.mobile,
          countryCode: this.state.countryCode,
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          email: this.state.email,
          isOptin: this.state.isOptin,
        },
        event: {
          id: this.businessDomainId,
        },
      },
    };
    FetchServerData.callPostService(CreateGroupContact_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          // let smsGroupContact = output.data.smsGroupContact;
          // this.getContactDetails(smsGroupContact?.smsContact?.id);
          if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
            this.props.navigate("/eventGroup", {
              state: {
                action: "view",
                groupId: this.state.groupId,
                contactId: this.state.contactId,
              },
            });
          } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
            this.props.navigate("/dptextGroup", {
              state: {
                action: "view",
                groupId: this.state.groupId,
                contactId: this.state.contactId,
              },
            });
          } else {
            this.props.navigate("/group", {
              state: {
                action: "view",
                groupId: this.state.groupId,
                contactId: this.state.contactId,
              },
            });
          }
          this.setState({
            addAnotherContact: true,
          });
        }
      }
    );
  }

  createContactToBackend() {
    if (!this.state.isOptin) {
      this.setState({
        error: true,
      });
      return;
    }
    const postObject = {
      header: this.header,
      smsContact: {
        mobile: this.state.mobile,
        countryCode: this.state.countryCode,
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        email: this.state.email,
        isOptin: this.state.isOptin,
        event: {
          id: this.businessDomainId,
        },
      },
    };
    FetchServerData.callPostService("/smscontactms/create", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          // let smsGroupContact = output.data.smsGroupContact;
          // this.getContactDetails(smsGroupContact?.smsContact?.id);
          this.props.navigate("/eventContacts");
          this.setState({
            addAnotherContact: true,
          });
        } else {
        }
      }
    );
  }

  createCancel() {
    if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
      if (this.state.pageId === "AllActives") {
        this.props.navigate("/eventContacts");
      } else {
        this.props.navigate("/eventGroup", {
          state: {
            action: "view",
            groupId: this.state.groupId,
          },
        });
      }
    } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
      if (this.state.pageId === "AllActives") {
        this.props.navigate("/dptextContacts");
      } else {
        this.props.navigate("/dptextGroup", {
          state: {
            action: "view",
            groupId: this.state.groupId,
            contactId: this.state.contactId,
          },
        });
      }
    } else {
      if (this.state.pageId === "AllActives") {
        this.props.navigate("/contacts", {
          state: {
            contactId: this.state.contactId,
          },
        });
      } else {
        this.props.navigate("/group", {
          state: {
            action: "view",
            groupId: this.state.groupId,
            contactId: this.state.contactId,
          },
        });
      }
    }
  }

  viewCancel() {
    if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
      if (this.state.pageId === "AllActives") {
        this.props.navigate("/eventContacts");
      } else {
        this.props.navigate("/eventGroup", {
          state: {
            action: "view",
            groupId: this.state.groupId,
          },
        });
      }
    } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
      if (this.state.pageId === "AllActives") {
        this.props.navigate("/dptextContacts");
      } else {
        this.props.navigate("/dptextGroup", {
          state: {
            action: "view",
            groupId: this.state.groupId,
          },
        });
      }
    } else {
      if (this.state.pageId === "AllActives") {
        this.props.navigate("/contacts", {
          state: {
            contactId: this.state.contactId,
          },
        });
      } else {
        this.props.navigate("/group", {
          state: {
            action: "view",
            groupId: this.state.groupId,
            contactId: this.state.contactId,
          },
        });
      }
    }
  }

  editCancel() {
    if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
      if (this.state.pageId === "AllActives") {
        this.props.navigate("/eventContacts");
      } else {
        this.props.navigate("/eventGroup", {
          state: {
            action: "view",
            groupId: this.state.groupId,
          },
        });
      }
    } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
      if (this.state.pageId === "AllActives") {
        this.props.navigate("/dptextContacts");
      } else {
        this.props.navigate("/dptextGroup", {
          state: {
            action: "view",
            groupId: this.state.groupId,
          },
        });
      }
    } else {
      if (this.state.pageId === "AllActives") {
        this.props.navigate("/contacts", {
          state: {
            contactId: this.state.contactId,
          },
        });
      } else {
        this.props.navigate("/group", {
          state: {
            action: "view",
            groupId: this.state.groupId,
            contactId: this.state.contactId,
          },
        });
      }
    }
  }

  editContactDetails(e) {
    this.setState({
      action: "edit",
      contactId: this.state.contactId,
    });
  }

  updateContactToBackend() {
    if (!this.state.isOptin) {
      this.setState({
        error: true,
      });
      return;
    }

    const postObject = {
      header: this.header,
      smsContact: {
        mobile: this.state.mobile,
        countryCode: this.state.countryCode,
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        email: this.state.email,
        isOptin: this.state.isOptin,
        id: this.state.contactId,
        event: {
          id: this.businessDomainId,
        },
      },
    };
    FetchServerData.callPostService(UpdateContact_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let smsContact = output.data.smsContact;
          if (this.state.pageId === "AllActives") {
            if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
              this.props.navigate("/eventContacts");
            } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
              this.props.navigate("/dptextContacts");
            } else {
              this.props.navigate("/contacts", {
                state: {
                  contactId: this.state.contactId,
                },
              });
            }
          } else {
            if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
              this.props.navigate("/eventGroup", {
                state: {
                  action: "view",
                  groupId: this.state.groupId,
                  contactId: this.state.contactId,
                },
              });
            } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
              this.props.navigate("/dptextGroup", {
                state: {
                  action: "view",
                  groupId: this.state.groupId,
                  contactId: this.state.contactId,
                },
              });
            } else {
              this.props.navigate("/group", {
                state: {
                  action: "view",
                  groupId: this.state.groupId,
                  contactId: this.state.contactId,
                },
              });
            }
          }
        } else {
        }
      }
    );
  }

  deleteContactToGroup() {
    const postObject = {
      header: this.header,
      smsGroupContact: {
        smsGroup: {
          id: this.state.groupId,
        },
        smsContact: {
          id: this.state.contactId,
        },
      },
    };

    FetchServerData.callPostService(DeleteContactFromGroup_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
            this.props.navigate("/eventGroup", {
              state: {
                action: "view",
                groupId: this.state.groupId,
                contactId: this.state.contactId,
              },
            });
          } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
            this.props.navigate("/dptextGroup", {
              state: {
                action: "view",
                groupId: this.state.groupId,
                contactId: this.state.contactId,
              },
            });
          } else {
            this.props.navigate("/group", {
              state: {
                action: "view",
                groupId: this.state.groupId,
                contactId: this.state.contactId,
              },
            });
          }
        } else {
        }
      })
      .catch((error) => { });
  }

  deleteContactToBackend() {
    const postObject = {
      header: this.header,
      smsContact: {
        id: this.state.contactId,
      },
    };

    FetchServerData.callPostService(DeleteContact_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.props.navigate("/contacts", {
            state: {
              contactId: this.state.contactId,
            },
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  addNewContact() {
    this.setState({
      action: "create",
      mobileNo: "",
      firstName: "",
      lastName: "",
      email: "",
      isOptin: false,
      contactId: this.state.contactId,
    });
  }

  render() {
    if (this.state.action === "create") {
      return this.createContact();
    } else if (this.state.action === "edit") {
      return this.editContact();
    } else {
      return this.viewContact();
    }
  }

  createContact() {
    return (
      <>
        <MenuWithBreadScrum
          breadCrumb={this.state.breadCrumb}
          navigate={this.props.navigate}
          editCallback={this.editContactDetails.bind(this)}
          deleteCallback={this.deleteContactToGroup.bind(this)}
          getDeletePermission={this.state.getDeletePermission}
          getUpdatePermission={this.state.getUpdatePermission}
          domainObject="Contact"
          name={`Add Contact to Group: ${this.state.groupName}`}
          pageId="viewPage"
          groupId={this.state.groupId}
        />
        <div className="row">
          <ValidatorForm
            className="text-start"
            ref="form"
            onSubmit={this.createGroupContactToBackend.bind(this)}
          >
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body" style={{ height: "100%" }}>
                    <div className="row">
                      <div className="col-md-4" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-firstname"
                        >
                          Mobile No.*
                        </label>
                        <span className="d-flex">
                          <PhoneInput
                            country={this.defaultCountry?.code
                              ?.toString()
                              ?.toLowerCase()}
                            value={this.state.countryCode}
                            onChange={(phone, country, e, formattedValue) => {
                              this.handleCountryChange(
                                phone,
                                country,
                                e,
                                formattedValue
                              );
                            }}
                            autoFormat
                            countryCodeEditable={false}
                            disableCountryGuess={false}
                            enableSearch={true}
                            alwaysDefaultMask={true}
                          />
                          <input
                            title=""
                            required
                            autoFocus={true}
                            type="text"
                            autoComplete="off"
                            id="multiStepsFirstName"
                            name="multiStepsFirstName"
                            className="form-control"
                            value={this.state.mobileNo}
                            onChange={this.handleMobileNoChange.bind(this)}
                          // onInvalid={(e) => {
                          //   e.target.setCustomValidity(
                          //     "Mobile number required"
                          //   );
                          // }}
                          />
                        </span>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-md-4" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-firstname"
                        >
                          First Name
                        </label>
                        <input
                          type="text"
                          autoComplete="off"
                          id="multiStepsFirstName"
                          name="multiStepsFirstName"
                          className="form-control"
                          value={this.state.firstName}
                          onChange={this.handleFirstNameChange.bind(this)}
                          validators={["required"]}
                          errormessages={["This field is required"]}
                        />
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-md-4" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-lastname"
                        >
                          Last Name
                        </label>
                        <input
                          type="text"
                          autoComplete="off"
                          id="multiStepsFirstName"
                          name="multiStepsFirstName"
                          className="form-control"
                          value={this.state.lastName}
                          onChange={this.handleLastNameChange.bind(this)}
                          validators={["required"]}
                          errormessages={["This field is required"]}
                        />
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-md-4" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-lastname"
                        >
                          Email
                        </label>
                        <input
                          type="text"
                          autoComplete="off"
                          id="multiStepsFirstName"
                          name="multiStepsFirstName"
                          className="form-control"
                          value={this.state.email}
                          onChange={this.handleEmailChange.bind(this)}
                          validators={["required"]}
                          errormessages={["This field is required"]}
                        />
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-md-12 d-flex" id="assetFormLabel">
                        <span
                          className="me-3 checkboxSize"
                          style={{ marginTop: "2px" }}
                        >
                          <FormControlLabel
                            style={{
                              color: "#000",
                              width: "100%",
                              margin: "0",
                              padding: "0",
                              height: "15px",
                            }}
                            control={
                              <Checkbox
                                variant="outlined"
                                id="isChecked"
                                checked={this.state.isOptin}
                                value={this.state.isOptin}
                                onChange={(e) => this.handleOptinChange(e)}
                                style={{
                                  background: "none",
                                  marginBottom: "2px",
                                }}
                              />
                            }
                            label={
                              <span className="m-1 form-label">
                                {`On behalf of ${this.companyName ? this.companyName : ""
                                  }, I verify that the person with this mobile number has given permission to be added to the opt-in list for this account.`}
                              </span>
                            }
                          />
                        </span>
                      </div>
                      {this.state.error ? (
                        <lable
                          className="danger"
                          style={{ color: "red", padding: "0px 43px" }}
                        >
                          Please verify opt-in
                        </lable>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row d-flex align-items-center justify-content-between">
              <div className="col-sm-12 mt-3 text-center">
                <CreateButton btnName="Create" type="submit" />
                &nbsp;&nbsp;
                <CancelIconButton onClick={(e) => this.createCancel()} />
              </div>
            </div>
          </ValidatorForm >
        </div >
      </>
    );
  }

  viewContact() {
    if (this.state.render === false) {
      return <div />;
    } else {
      return (
        <>
          <MenuWithBreadScrum
            breadCrumb={this.state.breadCrumb}
            navigate={this.props.navigate}
            domainObject={`${this.state.firstName} ${this.state.lastName}`}
            groupId={this.state.groupId}
            name="Contact Details"
            title="Contact"
            pageId="viewPage"
            editCallback={this.editContactDetails.bind(this)}
            backCallback={this.viewCancel.bind(this)}
            deleteCallback={
              this.state.pageId !== "AllActives"
                ? this.deleteContactToGroup.bind(this)
                : this.deleteContactToBackend.bind(this)
            }
            getDeletePermission={this.state.getDeletePermission}
            getUpdatePermission={this.state.getUpdatePermission}
          />
          <div className="row">
            <div className="col-md-12">
              <div className="card " id="giveBeeCard">
                <div
                  className="card-header d-flex align-items-center justify-content-between"
                  id="assetCardHeader"
                ></div>
                <div className="card-body">
                  <div className="row mb-4">
                    <div className="col-md-4">
                      <div className="row p-1">
                        <label
                          className="col-sm-4 col-form-label fw-bold"
                          htmlFor="basic-default-supplierType"
                          id="assetFormLabel"
                        >
                          Mobile No.
                        </label>
                        <div className="col-sm-8" id="givbeeText">
                          <span>
                            {`${this.state.countryCode}
                              ${Utils.phoneNumberFormate(this.state.mobileNo)}`}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="row p-1">
                        <label
                          className="col-sm-4 col-form-label fw-bold"
                          htmlFor="basic-default-supplierType"
                          id="assetFormLabel"
                        >
                          Name
                        </label>
                        <div className="col-sm-8" id="givbeeText">
                          <span>{`${this.state.firstName !== null
                            ? this.state.firstName
                            : ""
                            } ${this.state.lastName !== null
                              ? this.state.lastName
                              : ""
                            }`}</span>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="row p-1">
                        <label
                          className="col-sm-4 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Email
                        </label>
                        <div className="col-md-8" id="givbeeText">
                          <span>{this.state.email}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mb-4">
                    <div className="col-md-4">
                      <div className="row p-1">
                        <label
                          className="col-sm-4 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Opt-In
                        </label>
                        <div className="col-sm-8" id="givbeeText">
                          <span>{this.state.isOptin ? "Yes" : "No"}</span>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="row p-1">
                        <label
                          className="col-sm-4 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Active
                        </label>
                        <div className="col-sm-8" id="givbeeText">
                          <span>{this.state.isActive ? "Yes" : "No"}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-4 text-center">
            <BackButton
              type="button"
              style={{ backgroundColor: "#162c50", color: "#fff" }}
              variant="contained"
              onClick={(e) => this.viewCancel()}
            >
              Back
            </BackButton>
            {this.state.addAnotherContact && (
              <button
                id="ptsHollowButton"
                type="submit"
                style={{ padding: "5px 10px" }}
                className="btn btn-default "
                onClick={this.addNewContact.bind(this)}
              >
                Add Another Contact
              </button>
            )}
          </div>
        </>
      );
    }
  }

  editContact() {
    return (
      <>
        <MenuWithBreadScrum
          breadCrumb={this.state.breadCrumb}
          navigate={this.props.navigate}
          domainObject="Contact"
          name={
            this.state.pageId === "AllActives"
              ? "Edit Contact"
              : `Edit Contact to Group: ${this.state.groupName}`
          }
          pageId="viewPage"
          groupId={this.state.groupId}
        />
        <div className="row">
          <ValidatorForm
            className="text-start"
            ref="form"
            onSubmit={this.updateContactToBackend.bind(this)}
          >
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body" style={{ height: "100%" }}>
                    <div className="row">
                      <div className="col-md-4" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-firstname"
                        >
                          Mobile No.*
                        </label>
                        <span className="d-flex">
                          <PhoneInput
                            country={this.defaultCountry?.code
                              .toString()
                              .toLowerCase()}
                            value={this.state.countryCode}
                            onChange={(phone, country, e, formattedValue) => {
                              this.handleCountryChange(
                                phone,
                                country,
                                e,
                                formattedValue
                              );
                            }}
                            autoFormat
                            countryCodeEditable={false}
                            disableCountryGuess={false}
                            enableSearch={true}
                            alwaysDefaultMask={true}
                          />
                          <input
                            title=""
                            required
                            type="text"
                            autoComplete="off"
                            id="multiStepsFirstName"
                            name="multiStepsFirstName"
                            className="form-control"
                            value={this.state.mobileNo}
                            onChange={this.handleMobileNoChange.bind(this)}
                          // onInvalid={(e) => {
                          //   e.target.setCustomValidity(
                          //     "Mobile number required"
                          //   );
                          // }}
                          />
                        </span>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-md-4" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-firstname"
                        >
                          First Name
                        </label>
                        <input
                          type="text"
                          autoComplete="off"
                          id="multiStepsFirstName"
                          name="multiStepsFirstName"
                          className="form-control"
                          value={this.state.firstName}
                          onChange={this.handleFirstNameChange.bind(this)}
                          validators={["required"]}
                          errormessages={["This field is required"]}
                        />
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-md-4" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-lastname"
                        >
                          Last Name
                        </label>
                        <input
                          type="text"
                          autoComplete="off"
                          id="multiStepsFirstName"
                          name="multiStepsFirstName"
                          className="form-control"
                          value={this.state.lastName}
                          onChange={this.handleLastNameChange.bind(this)}
                          validators={["required"]}
                          errormessages={["This field is required"]}
                        />
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-md-4" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-lastname"
                        >
                          Email
                        </label>
                        <input
                          type="text"
                          autoComplete="off"
                          id="multiStepsFirstName"
                          name="multiStepsFirstName"
                          className="form-control"
                          value={this.state.email}
                          onChange={this.handleEmailChange.bind(this)}
                          validators={["required"]}
                          errormessages={["This field is required"]}
                        />
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-md-12 d-flex" id="assetFormLabel">
                        <span
                          className="me-3 checkboxSize"
                          style={{ marginTop: "2px" }}
                        >
                          <FormControlLabel
                            style={{
                              color: "#000",
                              width: "100%",
                              margin: "0",
                              padding: "0",
                              height: "15px",
                            }}
                            control={
                              <Checkbox
                                variant="outlined"
                                id="isChecked"
                                checked={this.state.isOptin}
                                value={this.state.isOptin}
                                onChange={(e) => this.handleOptinChange(e)}
                                style={{
                                  background: "none",
                                  marginBottom: "2px",
                                }}
                              />
                            }
                            label={
                              <span className="m-1 form-label">
                                {`On behalf of ${this.companyName ? this.companyName : ""
                                  }, I verify that the person with this mobile number has given permission to be added to the opt-in list for this account.`}
                              </span>
                            }
                          />
                        </span>
                      </div>
                      {this.state.error ? (
                        <lable
                          className="danger"
                          style={{ color: "red", padding: "0px 43px" }}
                        >
                          Please verify opt-in
                        </lable>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row d-flex align-items-center justify-content-between">
              <div className="col-sm-12 mt-3 text-center">
                <SaveButton btnName="Create" type="submit" />
                &nbsp;&nbsp;
                <CancelIconButton onClick={(e) => this.editCancel()} />
              </div>
            </div>
          </ValidatorForm >
        </div >
      </>
    );
  }
}

export default withRouter(NewContact);
